export const SET_CURRENT_ROUTE = 'ROUTER.SET_CURRENT_ROUTE';

export const setCurrentRoute = currentRoute => ({
  type: SET_CURRENT_ROUTE,
  currentRoute,
});
